export default {
  getInstituteUser: '/instituteUser/getInstituteUser',
  getUsersOfAnInstitute: '/instituteUser/getUsersOfAnInstitute',
  getInstituteProvidedId: '/instituteUser/getInstituteProvidedId',
  updateInstituteProvidedId: '/instituteUser/updateInstituteProvidedId'
}
